<div>
  <div v-if="spinner" :class="$style.pageMargin">
    <animation-processing fill="new-blue" :class="$style.pageSpinner"></animation-processing>
    <span class="mt-serif mt-serif--size3">
      {{$t('pages.contract.spinner.assigned_foundries')}}
    </span>
  </div>
  <div v-else-if="isNewApplicationResume" class="mt-wrapper">
    <h1 class="mt-h1">
      {{ $t('pages.foundry_application_status.continue_application_title') }}
    </h1>
    <p :class="[$style.desc]" v-html="$t('pages.foundry_application_status.continue_application_description')"></p>
    <div class="mt-25">
      <button type="button" @click="reapply('new')" class="mt-button">
        {{ $t('pages.foundry_application_status.get_started_continue') }}
      </button>
    </div>
  </div>
  <div v-else class="mt-wrapper">
    <h1 class="mt-h1">
      {{$t('pages.foundry_application_status.heading', {status: getStatusText})}}
    </h1>
    <div :class="[$style.desc]" v-html="getStatusDescription"></div>
    <div v-if="getAppStatusRejected">
      <h6 class="mt-h6-top">
        {{$t('pages.foundry_application_status.label')}}
      </h6>
      <div v-if="getAppStatusRejected" 
        :class="[$style.notes]"
        v-html="getNotesFromReviewer"></div>
    </div>
    <div class="mt-25">
      <a target="_blank" rel="noopener noreferrer" href="https://foundrysupport.monotype.com/" class="mt-button" v-if="getAppStatusInReview">
        {{$t('pages.foundry_application_status.learn_more')}}
      </a>
      <button @click="reapply('new')" class="mt-button" v-if="getAppStatusRejected">
        {{$t('pages.foundry_application_status.reapply')}}
      </button>
    </div>
  </div>
</div>
  